import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateWordWithNoSpace'
})
export class truncateWordWithNoSpace implements PipeTransform {
  // Note: keep the second parameter for backward compatibility, but it is not used.
  transform(valueInput: string | null | undefined, normalLength: number): string {

    const value = valueInput ?? ""


    // Split the string by whitespace to inspect individual elements
    const elements = value.trim().split(/\s+/);

    // Determine limit: if any element is longer than 50, use 50; otherwise use 200
    const limit = elements.some(e => e.length > 60) ? 60 : normalLength;

    let result = value;
    if (value.length > limit) {
      result = value.substring(0, limit);
      return result + '...';
    }

    return result;

    // Every returned string must end with ellipsis

  }
}
